import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class CacheService {
  private cache: Map<string, any> = new Map<string, any>();
  private cacheExpirationMs: number = 6 * 24 * 60 * 60 * 1000; // 6 дней в миллисекундах

  public getFromCache(key: string): Observable<any> | undefined {
    const cachedData = this.cache.get(key);
    if (cachedData && this.isCacheValid(cachedData.timestamp)) {
      return of(cachedData.data);
    }

    const dataFromLocalStorage = localStorage.getItem(key);
    if (dataFromLocalStorage) {
      const parsedData = JSON.parse(dataFromLocalStorage);
      if (this.isCacheValid(parsedData.timestamp)) {
        this.cache.set(key, parsedData);
        return of(parsedData.data);
      } else {
        this.cache.delete(key);
        localStorage.removeItem(key);
      }
    }

    return undefined;
  }

  public addToCache(key: string, data: Observable<any>): void {
    data.subscribe(
      (result) => {
        const cacheData = {
          data: result,
          timestamp: Date.now(),
        };
        this.cache.set(key, cacheData);
        localStorage.setItem(key, JSON.stringify(cacheData));
      },
      (error) => {
        console.error('Ошибка при записи данных в кэш:', error);
      }
    );
  }

  private isCacheValid(timestamp: number): boolean {
    return Date.now() - timestamp < this.cacheExpirationMs;
  }
}
